var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'asc-raw-report',
    _vm.isReportArray ? 'asc-raw-report--multiple' : 'asc-raw-report--sheet' ]},[_c('asc-spinner-wrapper',{attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"asc-raw-report--text-container",domProps:{"innerHTML":_vm._s(_vm.getReportText)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }